import React, { useState } from "react";
import { FaTrashAlt } from "react-icons/fa";
import { delete_workflows } from "../../services/ApiManageWorkflow";

function DeleteWorkflowBar({ selectedWorkflows, onDeleted }) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState("");

  const count = selectedWorkflows.length;

  const handleConfirmDelete = async () => {
    setIsDeleting(true);
    setError("");
    try {
      const ids = selectedWorkflows.map((w) => w.workflow_id);
      const result = await delete_workflows(ids);
      if (result) {
        onDeleted(ids);
        setShowConfirm(false);
      } else {
        setError("Failed to delete the selected workflow(s). Please try again.");
      }
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={() => {
          setError("");
          setShowConfirm(true);
        }}
        disabled={count === 0}
        style={{
          ...styles.deleteBtn,
          opacity: count === 0 ? 0.5 : 1,
          cursor: count === 0 ? "not-allowed" : "pointer",
        }}
      >
        <FaTrashAlt style={{ marginRight: 6 }} />
        Delete{count > 0 ? ` (${count})` : ""}
      </button>

      {showConfirm && (
        <div
          onClick={() => !isDeleting && setShowConfirm(false)}
          style={styles.overlay}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            style={styles.modal}
          >
            <h3 style={styles.modalTitle}>
              Delete {count} workflow{count > 1 ? "s" : ""}?
            </h3>
            <p style={styles.modalSubtitle}>
              This permanently removes the selected workflow{count > 1 ? "s" : ""} and
              all associated forecast data. This action cannot be undone.
            </p>

            <ul style={styles.workflowList}>
              {selectedWorkflows.map((w) => (
                <li key={w.workflow_id} style={styles.workflowListItem}>
                  {w.workflow_name}
                </li>
              ))}
            </ul>

            {error && <p style={styles.errorText}>{error}</p>}

            <div style={styles.modalActions}>
              <button
                type="button"
                onClick={() => setShowConfirm(false)}
                disabled={isDeleting}
                style={styles.cancelBtn}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleConfirmDelete}
                disabled={isDeleting}
                style={styles.confirmBtn}
              >
                {isDeleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DeleteWorkflowBar;

const styles = {
  deleteBtn: {
    display: "inline-flex",
    alignItems: "center",
    padding: "8px 16px",
    borderRadius: 8,
    border: "none",
    color: "#fff",
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "Poppins, sans-serif",
    background: "#973848",
    boxShadow: "0 3px 10px rgba(151, 56, 72, 0.25)",
  },
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(2, 26, 48, 0.65)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: "20px",
  },
  modal: {
    width: "100%",
    maxWidth: "480px",
    background: "#ffffff",
    borderRadius: "20px",
    padding: "28px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
    border: "1px solid #e6eef4",
    fontFamily: "Poppins, sans-serif",
  },
  modalTitle: {
    margin: 0,
    fontSize: 20,
    fontWeight: 700,
    color: "#0F172A",
  },
  modalSubtitle: {
    margin: "10px 0 0",
    fontSize: 14,
    color: "#475569",
    lineHeight: 1.6,
  },
  workflowList: {
    margin: "16px 0 0",
    padding: "12px 16px",
    borderRadius: 12,
    background: "#F8FAFC",
    border: "1px solid #CBD5E1",
    maxHeight: 160,
    overflowY: "auto",
    listStyle: "disc",
    color: "#0c3c54",
    fontSize: 13,
  },
  workflowListItem: {
    padding: "2px 0",
  },
  errorText: {
    margin: "14px 0 0",
    fontSize: 13,
    color: "#973848",
    fontWeight: 600,
  },
  modalActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    marginTop: 22,
  },
  cancelBtn: {
    padding: "9px 18px",
    borderRadius: 8,
    border: "1px solid #e6eef4",
    background: "#fff",
    color: "#0c3c54",
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "Poppins, sans-serif",
    cursor: "pointer",
  },
  confirmBtn: {
    padding: "9px 18px",
    borderRadius: 8,
    border: "none",
    background: "#973848",
    color: "#fff",
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "Poppins, sans-serif",
    cursor: "pointer",
    boxShadow: "0 3px 10px rgba(151, 56, 72, 0.25)",
  },
};
